module.exports = __webpack_public_path__ + "static/media/cosmic-night.9cfe36ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/cosmic-night.jpg
// module id = 195
// module chunks = 0